import {createSelector} from 'reselect';

const transportationReducerSelector = state => state.transportation;

const transportationSelector = createSelector(
    transportationReducerSelector,
    transportationReducer => transportationReducer.get('payload')
);

const transportationIsFetchingSelector = createSelector(
    transportationReducerSelector,
    transportationReducer => transportationReducer.get('isFetching')
);

const transportationErrorSelector = createSelector(
    transportationReducerSelector,
    transportationReducer => transportationReducer.get('error')
);

export {
    transportationSelector,
    transportationIsFetchingSelector,
    transportationErrorSelector
};
